import React from 'react';
import { FaTruck, FaGem, FaHandshake, FaBolt } from 'react-icons/fa';

const reasons = [
  {
    icon: FaGem,
    title: 'Kvalitné materiály',
    desc: 'Ponúkame len overené a certifikované stavebné materiály najvyššej kvality.',
  },
  {
    icon: FaTruck,
    title: 'Vlastná doprava',
    desc: 'Zabezpečíme dopravu priamo na vašu stavbu vlastnými vozidlami rýchlo a spoľahlivo.',
  },
  {
    icon: FaHandshake,
    title: 'Férové ceny',
    desc: 'Transparentné ceny bez skrytých poplatkov. Bezplatná cenová ponuka na požiadanie.',
  },
  {
    icon: FaBolt,
    title: 'Rýchle dodanie',
    desc: 'Operatívna dodávka materiálu podľa vašich potrieb a termínov.',
  },
];

function WhyUs() {
  return (
    <div id="why-us" className="bg-gray-50 py-20 px-6">
      <div className="max-w-screen-xl mx-auto">
        <div className="text-center text-5xl font-bold mb-14 text-gray-800">
          Prečo si <span className="text-red-600">vybrať nás?</span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((r, i) => (
            <div
              key={i}
              className="bg-white p-8 rounded-xl shadow-md text-center hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <r.icon className="text-red-600 text-5xl mx-auto mb-4" />
              <h3 className="font-bold text-xl mb-2">{r.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WhyUs;
